import Vue from 'vue';
import { SliderManager } from '@/components/Slider';
import { RootElementAttrsHolder } from '@/plugins/RootElementAttrsPlugin';
import { SliderProps, SlideStruct, SwiperOptions } from '@/components/Slider/types';
import { JSONParser } from '@/utils/JSONParser';

export function createSliderWidget(el: Element) {
    const rootAttrs = new RootElementAttrsHolder(el);
    const parser = new JSONParser('createSliderWidget');

    const component = el.getAttribute('data-component') || undefined!; // если будет null, дефолтный пропс не сработает
    const slides = el.getAttribute('data-slides');
    const url = el.getAttribute('data-url')!;
    const sliderOptions = el.getAttribute('data-slider-options')!;
    const parallax = el.getAttribute('data-parallax');
    const labels = el.getAttribute('data-labels');
    const sliderContainerClass = el.getAttribute('data-slider-container-class')!;
    const sliderClass = el.getAttribute('data-slider-class')!;
    const slideClass = el.getAttribute('data-slide-class')!;
    const sliderActiveSlide = el.getAttribute('data-slider-active-slide')!;
    const galleryId = el.getAttribute('data-gallery-id')!;

    const props: SliderProps = {
        component,
        slides: parser.parse<SlideStruct[]>(slides),
        url,
        sliderOptions: parser.parse<SwiperOptions>(sliderOptions),
        parallax: Boolean(parallax),
        labels: Boolean(labels),
        sliderContainerClass,
        sliderClass,
        slideClass,
        sliderActiveSlide: Number(sliderActiveSlide) || 0,
        galleryId,
    };

    return new Vue({
        el,
        rootAttrs,
        render: (h) => h(SliderManager, { props }),
    });
}
